(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
/**
 * Alennuskoodi ostoskorilaatikossa.
 *
 * Shopifyn Ajax-korti API ei osaa lisätä alennuskoodia koriin, joten koodi
 * välitetään kassalle checkout-linkin ?discount-parametrissa. Koodi luetaan
 * vasta kassalle siirryttäessä, jolloin korin uudelleenrenderöinti (ostoskorin
 * päivitys) ei pääse hukkaamaan sitä.
 */
document.addEventListener('click', function (evt) {
  var checkoutLink = evt.target.closest('.js-cart-checkout');
  if (checkoutLink) {
    var codeInput = document.querySelector('.js-cart-discount-input');
    var code = codeInput && codeInput.value.trim();
    if (code) {
      var url = new URL(checkoutLink.getAttribute('href'), window.location.origin);
      url.searchParams.set('discount', code);
      checkoutLink.setAttribute('href', url.pathname + url.search);
    }
    return;
  }

  var applyBtn = evt.target.closest('.js-cart-discount-apply');
  if (!applyBtn) return;
  evt.preventDefault();

  var form = applyBtn.closest('.cart-discount-form');
  var input = form && form.querySelector('.js-cart-discount-input');
  var note = form && form.parentNode.querySelector('[data-cart-discount-note]');
  if (!input || !note) return;

  if (input.value.trim()) {
    note.hidden = false;
  } else {
    note.hidden = true;
    input.focus();
  }
});

document.addEventListener('keydown', function (evt) {
  if (evt.key !== 'Enter') return;
  if (!evt.target.classList || !evt.target.classList.contains('js-cart-discount-input')) return;
  evt.preventDefault();
  var btn = evt.target.parentNode.querySelector('.js-cart-discount-apply');
  if (btn) btn.click();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
/**
 * Header piiloon alaspäin vierittäessä ja takaisin esiin ylöspäin.
 *
 * Luokat lisätään .section-header-kääreeseen, koska sticky-asemointi tarvitsee
 * vierityskontekstin – page-header-elementin oma vanhempi on juuri headerin
 * korkuinen, eikä sticky toimisi sen sisällä.
 */
(function () {
  var MIN_DELTA = 8;
  var lastY = window.scrollY;

  function header() {
    var el = document.querySelector('page-header[data-reveal-on-scroll-up]');
    return el ? el.closest('.section-header') : null;
  }

  function init() {
    var section = header();
    if (section) section.classList.add('section-header--reveal');
  }

  window.addEventListener('scroll', function () {
    var section = header();
    if (!section) return;

    var y = window.scrollY;
    var delta = y - lastY;
    if (Math.abs(delta) < MIN_DELTA) return;

    // Ei piiloteta ennen kuin header on kokonaan vieritetty ohi, eikä silloin
    // kun valikko on auki.
    var navOpen = section.classList.contains('section-header--nav-open')
      || document.body.classList.contains('reveal-mobile-nav');

    if (delta > 0 && y > section.clientHeight && !navOpen) {
      section.classList.add('section-header--reveal-hidden');
    } else if (delta < 0) {
      section.classList.remove('section-header--reveal-hidden');
    }

    lastY = y;
  }, { passive: true });

  init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
/**
 * Sticky add to cart: hinnan päivitys varianttivalitsimesta.
 *
 * Valitsin on name="id", joten ostoskoriin lisäys toimii ilman JS:ää. Tämä
 * huolehtii vain näytettävästä hinnasta. Kuuntelija on dokumenttitasolla,
 * jotta se toimii myös kun teema renderöi palkin uudelleen variantin
 * vaihtuessa.
 */
document.addEventListener('change', function (evt) {
  var select = evt.target.closest('[data-sticky-variant-select]');
  if (!select) return;

  var option = select.options[select.selectedIndex];
  var priceWrap = document.querySelector('[data-sticky-price]');
  if (!option || !priceWrap) return;

  var current = priceWrap.querySelector('[data-sticky-price-current]');
  var was = priceWrap.querySelector('[data-sticky-price-was]');

  if (current) current.innerHTML = option.dataset.price || '';
  if (was) {
    was.innerHTML = option.dataset.compare || '';
    was.hidden = !option.dataset.compare;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
